import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { TalentInboxComponent } from "./talent-inbox.component";
import { TalentConversationComponent } from "./subfolder/talent-conversation/talent-conversation.component";
import { MessagesConversationResolver } from "../../../../common-componnets/messages/messages-conversation.resolver";
import { LoginDataResolver } from "../../../login-page/login-page-data/login-data.resolver";

const routes: Routes = [
  {
    path: "",
    component: TalentInboxComponent,
    resolve: {
      loginData: LoginDataResolver,
    }
  },
  {
    path: "conversation/:id",
    component: TalentConversationComponent,
    resolve: {
      conversation: MessagesConversationResolver,
    },
    runGuardsAndResolvers: "always"
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TalentInboxRoutingModule {}
